import {
  StackScrollTool,
  WindowLevelTool,
  ZoomTool,CrosshairsTool,
} from "@cornerstonejs/tools";
import { DirectionalHint, TooltipDelay, TooltipHost } from "@fluentui/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import DropDown from "../../../../../components/SVGComponents/Tools/DropDown";
import { isMobile } from "react-device-detect";
import {
  STACK_SCROLL_DROPDOWN_ELEMENTS,
  TOAST_TYPE,
} from "../../../../../constants/Constants";
import themeContext from "../../../../../context/theme/ThemeContext";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import StackScroll from "../../../../../components/SVGComponents/Tools/StackScroll";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import ThumbnailContext from "../../../../../context/studyviewer/ThumbnailContext";
import Zoom from "../../../../../components/SVGComponents/Zoom";
import {
  enableVOISync,
  fitToScreen,
  loadMPR,
  originalResolution,
  resizeViewport,
  disable3DViewport,
} from "../../../helpers/CornerstoneViewportService";
import MPR from "../../../../../components/SVGComponents/Tools/MPR";
import loaderContext from "../../../../../context/loader/LoaderContext";
import { isReconstructable } from "../../../helpers/MPRService";
import { useTranslation } from "react-i18next";
import toastContext from "../../../../../context/toast/ToastContext";

const toolTipStyles = {
  root: {
    height: "20px",
  },
};
const MPRToolComponent = () => {
  const dropDownRef = useRef(null);
  const { theme } = useContext(themeContext);
  const [showDropDown, setShowDropDown] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [dropDownHovered, setDropDownHovered] = useState(false);
  const {
    activeTool,
    setActiveTool,
    setPreviousActiveTool,
    activeMPRTool,
    isMPRActive,
    activeViewportIndex,
    activeMPRViewportIndex,
    setActiveMPRViewportIndex,
    isSagittalActive,
    setIsSagittalActive,
    isAxialActive,
    setIsAxialActive,
    isCoronalActive,
    setIsCoronalActive,
    setIsMPRActive,
    setActiveMPRTool,
    viewportSeriesData,
    setMprLoading,
    setMprViewportElements,
    setIsMPRViewportActivated,
    setMPRViewportLoaderRunning,
    setVolumeId,
    isMPREnabled,
    is3DActive,
    setIs3DActive,
  } = useContext(ViewportContext);
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const { setActiveMPRThumbnailIndex, activeThumbnailIndex } =
    useContext(ThumbnailContext);
  const { showToastv2 } = useContext(toastContext);
  const { setProgressComplete, setProgress, setShowToast } =
    useContext(studyviewerContext);
  const { t } = useTranslation();
  const changeActiveTool = async (tool) => {
    // eventTarget.reset();
    if (activeTool === tool) {
      setPreviousActiveTool(activeTool);
      setActiveTool(StackScrollTool.toolName);
    } else {
      setPreviousActiveTool(activeTool);
      setActiveTool(tool);
    }
  };

  const handleMouseLeave = () => {
    setHovered(false);
    // setShowDropDown(false);
  };

  const handleMouseOver = () => {
    setHovered(true);
    setShowDropDown(true);
  };

  const handleDropDownClick = () => {
    setShowDropDown(!showDropDown);
    // changeActiveTool(toolName);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setShowDropDown(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const handleFitToScreen = async () => {
    if (isMPRActive) {
      await fitToScreen(activeMPRViewportIndex, isMPRActive);
    } else {
      await fitToScreen(activeViewportIndex, isMPRActive);
    }
    setShowDropDown(false);
  };

  const handleOriginalResolution = async () => {
    if (isMPRActive) {
      await originalResolution(activeMPRViewportIndex, isMPRActive);
    } else {
      await originalResolution(activeViewportIndex, isMPRActive);
    }
    setShowDropDown(false);
  };

  const toggleMPR = async (tool) => {
    if (isMPRActive){
      // await loadMPR(
      //   activeViewportIndex,
      //   "viewport",
      //   viewportSeriesData[activeViewportIndex].series,
      //   setMprLoading,
      //   setMprViewportElements
      // );
      return;
    }
    setMPRViewportLoaderRunning(true)
    // setShowToast((prev) => {
    //   return {
    //     ...prev,
    //     show: false,
    //     message: "",
    //     loading: true,
    //     state: "",
    //   };
    // });

    const isSeriesReconstructable = await isReconstructable(
      activeViewportIndex,
      "viewport",
      setProgress
    );

    if (!isSeriesReconstructable.value) {
      setMPRViewportLoaderRunning(false)
      showToastv2(TOAST_TYPE.ERROR, t("mpr.not-reconstructable"));
      return;
    }
    //setActiveMPRTool(WindowLevelTool.toolName);
    setActiveMPRTool(CrosshairsTool.toolName);
    setActiveMPRThumbnailIndex(activeThumbnailIndex);
    setIsMPRActive(!isMPRActive);
    setTimeout(async () => {
      await loadMPR(
        activeViewportIndex,
        "viewport",
        viewportSeriesData[activeViewportIndex].series,
        setMprLoading,
        setMprViewportElements,
        setIsMPRViewportActivated,
        setVolumeId
      );
      // setMPRViewportLoaderRunning(false);
    }, 1500);
    enableVOISync();
  };

  return (
    <>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <div
          style={{
            height: "100%",
            position: "relative",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div
            style={{
              height: "100%",
              width: `${isMobile ? "60px" : "100%"}`,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                height: "65%",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  height: "100%",
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                }}
                onMouseOver={isMPREnabled ? handleMouseOver : undefined}
                onMouseLeave={isMPREnabled ? handleMouseLeave : undefined}
                onClick={isMPREnabled ? handleDropDownClick : undefined}

              >
                {/* <TooltipHost
                  delay={TooltipDelay.zero}
                  id={"zoomtool"}
                  directionalHint={DirectionalHint.bottom}
                  styles={toolTipStyles}
                  content={isMobile ? "" : "MPR"}
                  className={"myToolTip"}
                > */}
                  <MPR
                    color={isMPREnabled ? 
                      isMPRActive || hovered
                        ? theme.palette.activeTool
                        : theme.palette.inactiveTool : theme.palette.inactiveTool
                    }
                    iconStyle={isMPREnabled ? {opacity: 1} : {opacity: "0.4"}}
                  />
                {/* </TooltipHost> */}
              </div>
              {/* <div
                style={{ marginLeft: "10px" }}
                onClick={handleDropDownClick}
                onMouseOver={() => setDropDownHovered(true)}
                onMouseLeave={() => setDropDownHovered(false)}
              >
                <DropDown
                  color={
                    dropDownHovered || hovered
                      ? theme.palette.activeTool
                      : theme.palette.inactiveTool
                  }
                />
              </div> */}
            </div>
            {isMobile && (
              <span
                style={{
                  fontSize: "8px",
                  lineHeight: "100%",
                  fontWeight: "400",
                  color: "#FFFFFF",
                }}
              >
                {t("mpr.mpr-tools")}
              </span>
            )}
          </div>
        </div>

        {isMPREnabled && showDropDown && (
          <div
            className={
              isMobile ? "dropdow-bottom-position viewer-tool-more-dropdown" : "dropdow-top-position viewer-tool-more-dropdown"
            }
            ref={dropDownRef}
            style={{
              flexDirection: "column",
              position: "absolute",
              // top : window.innerHeight * 0.075,
              ...(isMobile ? {} : { top: "100%" }),
              zIndex: "999",
              // backgroundColor: "#201F1E",
              boxShadow:
                "0px 0.6px 1.8px rgba(0, 0, 0, 0.1), 0px 3.2px 7.2px rgba(0, 0, 0, 0.13)",
              borderRadius: "5px",
              paddingLeft: "10px",
              paddingRight: "20px",
            }}
          >
            <div
              onClick={() => {
                toggleMPR();
                setIsCoronalActive(false);
                setIsSagittalActive(false);
                setIsAxialActive(true);
                if (is3DActive) { setIs3DActive(false); disable3DViewport(); }
                resizeViewport();
                setShowDropDown(false);
              }}
              className="stack-scroll-dropdown-elements"
            >
              {t("mpr.axial")}
            </div>
            <div
              onClick={() => {
                toggleMPR();
                setIsAxialActive(false);
                setIsCoronalActive(false);
                setIsSagittalActive(true);
                if (is3DActive) { setIs3DActive(false); disable3DViewport(); }
                resizeViewport();
                setShowDropDown(false);
              }}
              className="stack-scroll-dropdown-elements"
            >
              {t("mpr.sagittal")}
            </div>
            <div
              onClick={() => {
                toggleMPR();
                setIsAxialActive(false);
                setIsSagittalActive(false);
                setIsCoronalActive(true);
                if (is3DActive) { setIs3DActive(false); disable3DViewport(); }
                resizeViewport();
                setShowDropDown(false);
              }}
              className="stack-scroll-dropdown-elements"
            >
              {t("mpr.coronal")}
            </div>
            <div
              onClick={() => {
                toggleMPR(true);
                setIsAxialActive(false);
                setIsSagittalActive(false);
                setIsCoronalActive(false);
                setIs3DActive(false);
                disable3DViewport();
                resizeViewport();
                setShowDropDown(false);
              }}
              className="stack-scroll-dropdown-elements"
            >
              {t("mpr.mpr")}
            </div>
            <div
              onClick={() => {
                toggleMPR(true);
                setIsAxialActive(false);
                setIsSagittalActive(false);
                setIsCoronalActive(false);
                setIs3DActive(true);
                setActiveMPRViewportIndex(0);
                resizeViewport();
                setShowDropDown(false);
              }}
              className="stack-scroll-dropdown-elements"
            >
              {t("mpr.3d")}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MPRToolComponent;
